import { useSelector } from "react-redux";
import { IconDispatcher } from "shared/Icons";
import styled from "styled-components/macro";

export function InsightTypeCard({ gemColor, type }) {
	const { gainInsights, painInsights } = useSelector((state) => state.analytics?.journeyTrend?.currentData);

	let value = 0;
	const insights = type === "gain" ? gainInsights : painInsights;

	Object.keys(insights)?.forEach((insightId) => {
		value += insights[insightId]?.value;
	});

	return (
		<Container>
			<IconContainer color={gemColor}>{IconDispatcher("gem", "", { style: "light" })}</IconContainer>
			<Value>{value}</Value>
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
`;

const Value = styled.div`
	color: #262626;
	text-align: center;
	font-family: "Oswald";
	font-size: 48px;
	font-style: normal;
	font-weight: 600;
	line-height: 48px;
`;

const IconContainer = styled.div`
	svg {
		height: 48px;
		width: 48px;
	}
	path {
		fill: ${({ color }) => color};
	}
`;
